export default function Container({ children }) {
	return (
		<div
			style={{
				width: "1800px",
				margin: "0 auto",
				maxWidth: "100%",
				textAlign: "center",
			}}
		>
			{children}
		</div>
	);
}
